import { ErrorBoundary } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Center } from 'native-base';
import React from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { tradingCustomerPlatformsQuery } from '../../../../../store/trading/selector';
import { CustomerPlatformsItem } from '../../../../../store/trading/types';

import { ContentDesktop } from './Desktop';
import { ContentMobile } from './Mobile';
import { ContentTablet } from './Tablet';

export interface PlatformQueryContainerProps {
  accountId: number;
}

export interface PlatformQueryContainerDataProps {
  data: CustomerPlatformsItem[];
  isLoading: boolean;
}

export const PlatformQueryContainer: React.FC<PlatformQueryContainerProps> = ({ accountId }) => {
  const { refresher, data, error, loading } = useRecoilQuery(
    tradingCustomerPlatformsQuery({ idConta: accountId })
  );

  const content = useBreakpointValue({
    base: <ContentMobile isLoading={loading} data={data?.data || []} />,
    sm: <ContentTablet isLoading={loading} data={data?.data || []} />,
    md: <ContentDesktop isLoading={loading} data={data?.data || []} />,
  });

  if (error) {
    return (
      <Center flex={1} backgroundColor={Color['neutral.white']}>
        <ErrorBoundary onRefresh={refresher} />
      </Center>
    );
  }

  return content;
};
